import script from "./FooterMain.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMain.vue?vue&type=script&setup=true&lang=js"

import "./FooterMain.vue?vue&type=style&index=0&id=6a93e8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a93e8d2"]])

export default __exports__